export const iconFontAwesomeDesignCopy = (
	<i className="fa-solid fa-copy"></i>
);
